import { render, staticRenderFns } from "./send-email-invoice-button.vue?vue&type=template&id=47d2ebce&scoped=true"
import script from "./send-email-invoice-button.vue?vue&type=script&lang=js"
export * from "./send-email-invoice-button.vue?vue&type=script&lang=js"
import style0 from "./send-email-invoice-button.vue?vue&type=style&index=0&id=47d2ebce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d2ebce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47d2ebce')) {
      api.createRecord('47d2ebce', component.options)
    } else {
      api.reload('47d2ebce', component.options)
    }
    module.hot.accept("./send-email-invoice-button.vue?vue&type=template&id=47d2ebce&scoped=true", function () {
      api.rerender('47d2ebce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/modules/invoice/components/buttons/send-email-invoice-button.vue"
export default component.exports